<template>
  <div class='xy-content-module'>
    <div class='xy-content-body-ipad'>
      <van-nav-bar style="flex:1" fixed>
        <div slot="left" @click="close">
          <van-icon name="arrow-left" color="#333" size="20" />
        </div>
        <div slot="title">
          <div class="titlediv">选择学生</div>
        </div>
      </van-nav-bar>
      <div class="grade-ul-div">
        <div v-if="gradeList.length === 0 && isLoad" class="assessView null-data">
          <img src="@/assets/common/moblie-no-data.png" />
          <div>当前方案暂无学生</div>
        </div>
        <ul class="grade-ul">
          <li class="grade-li" :style="{border:item.checked?'1px solid #1677FF':'1px solid #D5D5D5'}" v-for="(item,index) in gradeList" :key='index' @click="activeHand(item)">
            <div class="li-img">
              <span v-if="item.StudentIcon===''" class="icons man">{{xy.showName(item.StudentFullName)}}</span>
              <img v-else :src="item.StudentIcon" alt="">
            </div>
            <div class="li-text">{{item.StudentFullName?item.StudentFullName.slice(-4):''}}
            </div>
            <span class="li-fenshu">{{item.ActivityCourseScoreSum}}</span>
            <div class="li-active" v-if="item.checked">
              <img src="./img/group.png" alt="">
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="isEdit" class="sigle-bottom-btn">
      <div class="info-btn" @click="ok">确认</div>
    </div>
  </div>
</template>
<script>
import { Toast } from 'vant'
  export default {
    name: 'ActivityEvaluationStuList',
    data () {
      return {
        selectAll: [],
        scoreDatas: [],
        targetList: [],
        ActivityCourseProjectID: 0,
        scoreType: 0,
        isEdit: false,
        gradeList: [],
        isLoad: false,
        ApplicationID:0,
        ApplicationSubMenuID:0
      }
    },
    created () {
      Toast.setDefaultOptions('loading', { duration: 0 })
      console.log(this.$store.state.evaluation.ipadpjgetMenuIDs)
      this.ApplicationID = this.$store.state.evaluation.ipadpjgetMenuIDs[0]
      this.ApplicationSubMenuID = this.$store.state.evaluation.ipadpjgetMenuIDs[1]
      this.isEdit = Boolean(this.$route.query.isEdit)
      this.scoreDatas = JSON.parse(this.$route.query.scoreDatas)// 指标数据
      this.ActivityCourseProjectID = Number(this.$route.query.ActivityCourseProjectID)
      this.scoreType = Number(this.$route.query.scoreType)
      this.getClassList()
    },
    mounted () {},
    methods :{
      loading() {
        Toast.loading({
          message: '加载中...',
          className: 'ipad_toast',
          forbidClick: true
        })
      },
      unloading() {
        Toast.clear()
      },
      fail(a, b) {
        if (b) {
          Toast.success({
            message: a,
            className: 'ipad_toast',
            forbidClick: true
          })
        } else {
          Toast.fail({
            message: a,
            className: 'ipad_toast',
            forbidClick: true
          })
        }
      },
      // 获取学生列表
      async getClassList() {
        this.loading()
        let res = await this.xyapi.get(
          `${this.xyMApi}/eva/api/ActivityCourseProjectPad/GetTeacherStudentByProjectID`,
          {
            ActivityCourseProjectID: this.ActivityCourseProjectID,
            ApplicationID: this.ApplicationID,
            ApplicationSubMenuID: this.ApplicationSubMenuID
          }
        )
        this.unloading()
        if (res.success) {
          this.gradeList = res.data
          this.isLoad = true
          this.gradeList.forEach ((item) => {
            this.$set(item, 'checked', false)
          })
        }
      },
      pickTarget () {
        let arr = []
        for (let iv of this.scoreDatas) {
          if (iv.Level === 1 && iv.Childrens.length === 0) {
            arr.push({
              ActivityCourseTargetID: iv.ActivityCourseProjectTargetID,
              ActivityCourseScoreType: this.scoreType,
              ActivityCourseScore: iv.DefaultValue,
              markName: iv.title,
              MinValue: iv.MinValue,
              ActivityCourseScoreConversion: iv.ConversionValue || 1
            })
          }
          if (iv.Level === 2 && iv.Childrens.length === 0) {
            arr.push({
              ActivityCourseTargetID: iv.ActivityCourseProjectTargetID,
              ActivityCourseScoreType: this.scoreType,
              ActivityCourseScore: iv.DefaultValue,
              markName: iv.title,
              MinValue: iv.MinValue,
              ActivityCourseScoreConversion: iv.ConversionValue || 1
            })
          }
          if (iv.Level === 3) {
            arr.push({
              ActivityCourseTargetID: iv.ActivityCourseProjectTargetID,
              ActivityCourseScoreType: this.scoreType,
              ActivityCourseScore: iv.DefaultValue,
              markName: iv.title,
              MinValue: iv.MinValue,
              ActivityCourseScoreConversion: iv.ConversionValue || 1
            })
          }
        }
        this.targetList = arr
      },
      // 保存打分
      async saveScore() {
        this.pickTarget()
        this.loading()
        let arr = []
        for (let i = 0; i < this.targetList.length; i++) {
          let item = this.targetList[i]
          arr.push({
            ActivityCourseTargetID: item.ActivityCourseTargetID,
            ActivityCourseScoreType: item.ActivityCourseScoreType,
            ActivityCourseScore: item.ActivityCourseScore,
            ActivityCourseScoreConversion: item.ActivityCourseScoreConversion
          })
          if (item.ActivityCourseScore < item.MinValue) {
            this.fail(`指标项评价最小值为${item.MinValue}`)
            return false
          }
        }
        let params = {
          'ActivityCourseProjectID': this.ActivityCourseProjectID,
          'ActivityCourseStudentIDs': this.selectAll.map(val => val.ActivityCourseStudentID),
          'ScoreData': arr
        }
        let res = await this.xyapi.post(`${this.xyMApi}/eva/api/ActivityCourseProjectPad/TeacherTeachingScore`, params)
        this.unloading()
        if (res.success) {
          this.fail(res.msg || '保存成功。', true)
          setTimeout(() => {
            this.close()
          }, 1000)
        }
      },
      close() {
        this.$router.go(-1)
      },
      activeHand(item){
        let indexs = -1
        item.checked = item.checked ? false : true
        if(item.checked){
          this.selectAll.push(item)
        }else{
          for(let i=0,len=this.selectAll.length;i<len;i++){
            if(this.selectAll[i].StudentID ===item.StudentID){
              indexs=i
            }
          }
        }
        if(indexs!==-1)
          this.selectAll.splice(indexs,1)
      },
      ok(){
        if (this.selectAll.length !== 0) {
          this.saveScore()
        } else {
          this.fail("请先选择要评价的学生")
        }
      }
    }
  }
</script>
<style lang='less'>
.assessView {
  width: 100%;
  height: 670px;
}
.null-data {
  margin-top: 100px;
  text-align: center;
  div {
    // prettier-ignore
    font-size:18Px;
  }
}
.titlediv {
  font-size: 16px;
}
.man {
  background: #4196ff;
}
.woman {
  background: #FF81AC;
}
.van-nav-bar {
  height: 60px;
  line-height: 60px;
  color: #1a1a1a;
  font-weight: 500;
}
.van-dialog__message {
  font-size: 16px !important;
  padding: 3.2vw;
}
.van-button__text {
  font-size: 16px !important;
}
.van-button--large {
  height: 6.6vw;
  line-height: 3.2vw;
}
.xy-content-body-ipad{
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  .changeAll{
    background: #fff;
    height: 80px;
    width: 100%;
    border-bottom: 20px solid #f5f5f5;
    font-size: 18Px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    div{
      padding:10px;
      flex: 1;
      text-align: center;
      img{
        width:20px;
        height:20px;
        margin-left:10px;
      }
    }
  }
  .select-more{
    font-size: 22Px;
    text-align: center;
  }
  .grade-ul-div{
    width: 1004px;
    margin: 30px 10px 10px;
    padding-bottom: 120px;
    .grade-ul{
      padding: 20px 10px 20px 20px;
      background: #fff;
      display: flex;
      flex-wrap: wrap;
      .grade-li{
        width: 129px;
        height: 135px;
        border-radius: 4px;
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        margin-right: 10px;
        margin-bottom: 10px;
        justify-content: center;
        align-items: center;
        position: relative;
        .li-img{
          margin-bottom: 8px;
          margin-top:10px;
          .icons{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 54px;
            height: 54px;
            text-align: left;
            border-radius: 50%;
            font-size: 16Px;
            color: #fff;
          }
          img {
            width: 54px;
            height: 54px;
            text-align: left;
            border-radius: 50%;
          }
        }
        .li-text{
          width: 100px;
          text-align: center;
          overflow: hidden;
          font-size: 15Px;
          position: relative;
        }
        .li-fenshu{
          position: absolute;
          font-size: 20Px;
          color: #E27730;
          top:8px;
          right: 10px;
          font-weight: bold;
        }
        .li-active{
          width: 70px;
          height: 70px;
          position:absolute;
          top: 100px;
          left: 91px;
          img{
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
.sigle-bottom-btn {
  height: 60px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 21px 0px rgba(186, 186, 186, 0.44);
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  z-index: 99999 !important;
  align-items: center;
  justify-content: flex-end;
  padding: 0 15px;
  .info-btn {
    width: 74px;
    height: 32px;
    background: #1677ff;
    color: #fff;
    border-radius: 16px;
    text-align: center;
    line-height: 32px;
    font-size: 14Px;
  }
}

</style>
